import { DeskPageBodyComponents, DeskPageBodyProps } from '@my-types';
import { React, Styled } from '@common/3rd';
import { Utils, PATH, Storage } from '@common';
import { PageBody } from '@component';

/**
 * 桌面页面主体
 */
class DeskPageBody<P extends DeskPageBodyProps, S, C extends DeskPageBodyComponents> extends PageBody<P, S, C> {
	protected initComponents(): C {
		const C = super.initComponents();
		return Object.assign(C, {
			Box: Styled(C.Box)`
				// padding: 0 ${props => props.theme.DESK_HTML_HORIZONTAL_MARGIN}px;
				margin: 0 auto;
				margin-top: ${props => props.theme.DESK_PAGE_HEADER_HEIGHT}px;
				width: 85vw;
				${props => this.renderCSS(props.theme)}
			`,
			LOC: Styled(Styled.div`
				font-weight: ${props => props.theme.FONT_WEIGHT_BOLD};
				span:not(:first-child):before {
					content: '/';
					margin-right: 3px;
					margin-left: 3px;
				}
			`).attrs({
				'data-widget': 'desk-location'
			})``,
			Home: Styled.span`
				cursor: pointer;
				:hover {
					text-decoration: underline;
				}
			`
		});
	}
	private renderHomeLink(): JSX.Element | void {
		if (this.props.home !== false) {
			const C = this.getComponents();
			return <C.Home onClick={this.onHomeClicked}>首页</C.Home>;
		}
	}
	/**
	 * 描画页面所在位置
	 *
	 * @return {[React.Component]|React.Component}
	 */
	protected renderLocation() {
		const C = this.getComponents();
		const locations = this.getLocation();
		if (locations) {
			return (
				<C.LOC>
					{this.renderHomeLink()}
					{Utils.toArray(this.getLocation()).map((loc, index) => {
						return <span key={index}>{loc}</span>;
					})}
				</C.LOC>
			);
		}
	}
	/**
	 * 描画页面主体内容
	 */
	protected renderContent(): JSX.Element | null {
		return null;
	}
	/**
	 * 渲染内容如下:
	 * 1. location
	 * 2. children
	 * 3. content
	 */
	render() {
		const C = this.getComponents();
		return (
			<C.Box data-widget="desk-page-body">
				{this.renderLocation()}
				{this.props.children}
				{this.renderContent()}
			</C.Box>
		);
	}
	/**
	 * 获取当前页面的路径. 默认null
	 */
	protected getLocation(): string | string[] | null | undefined {
		return this.props.where;
	}
	private onHomeClicked = (): void => {
		//如果是第三方跳转过来的，优先使用第三方地址
		const thirdDeskHome = Storage.Share.getThirdDeskHome();
		if (thirdDeskHome) {
			window.location.replace(thirdDeskHome);
		} else {
			this.getHelpers()
				.getRouter()
				.pushRedirect(PATH.DESK_HOME);
		}
	};
}

export default DeskPageBody;
